import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"

import footerStyle from "./footer.module.scss"
import homeStyle from "./home.module.scss"

import backgroundImg from "../img/foot.png"

const Footer = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          author
        }
      }
    }
  `)
  return (
    <div className={footerStyle.footerWrapper}>
      <img
        className={footerStyle.backgroundImg}
        src={backgroundImg}
        alt="background"
      />
      <div className={footerStyle.container}>
        <div className={footerStyle.left}>
          <h4>
            NEED A DEVELOPER? <br></br>
            LET'S BUILD SOMETHING.
          </h4>
          <Link to="/contact">
            <button className={footerStyle.footerButton}>GET IN TOUCH</button>
          </Link>
        </div>
        <ul className={footerStyle.listWrapper}>
          <li>
            <a href="https://github.com/symoon94" target="_blank">
              GITHUB
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/in/sooyoung-moon/"
              target="_blank"
            >
              LINKEDIN
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/sooyoung__moon/" target="_blank">
              INSTAGRAM
            </a>
          </li>
          <li>
            <a href="https://twitter.com/Sooyoung_Luna" target="_blank">
              TWITTER
            </a>
          </li>
          <li>
            <a href="https://www.facebook.com/msy0128" target="_blank">
              FACEBOOK
            </a>
          </li>
        </ul>
      </div>

      <footer className={footerStyle.footer}>
        <p>© Copyright 2020 − {data.site.siteMetadata.author}</p>
      </footer>
    </div>
  )
}

export default Footer
